import React from 'react';
import { HeaderWrapper, HeaderImage, HeaderIcon } from './styles';
import { HeadIconItemAddToCart } from './pices/HeadIconItemAddToCart';

interface HeaderProps {
  imageUrl: string;
   IconComponent: React.ComponentType;

}

export const HeadItemAddToCart: React.FC<HeaderProps> = ({ imageUrl, IconComponent }) => {
  return (
    <HeaderWrapper>
      <HeaderImage src={imageUrl} alt="Header" />
      <HeaderIcon>
        <HeadIconItemAddToCart IconComponent={IconComponent} />
      </HeaderIcon>
    </HeaderWrapper>
  );
};